'use strict';

import { isHTMLElement } from "@popperjs/core/lib/dom-utils/instanceOf";
import getNodeName from "@popperjs/core/lib/dom-utils/getNodeName";
import MobileDetect from "mobile-detect";
import _ from "lodash";
import tippy from "tippy.js";

//directive main function injections
ossRecallDirective.$inject = [];

//directive main function
function ossRecallDirective() {
    var directive = {
        restrict: 'E',
        replace: true,
        controller: ossRecallDirectiveController,
        templateUrl: 'template/directives/recall',
        scope: {
            recall: '=',
            displayButtons: '<?',
            onToggle: '=?'
        }
    };
    return directive;

}

//directive controller function injections
ossRecallDirectiveController.$inject = ['$scope', '$element', '$attrs', 'recallParserService'];

//directive controller function
function ossRecallDirectiveController($scope, $element, $attrs, recallParserService) {
    $scope.formatted = false;
    $scope.longDescriptionEnabled = window.appSettings.displayRecallLongDescription;

    const el = $element[0];
    let tippyInstance;

    this.$postLink = function () {
        init();

        if ($scope.longDescriptionEnabled) {
            tippyInstance = tippy(el.querySelector(".options__item--long-description__info"), {
                arrow: true,
                // content: "Bla Bla",
                theme: 'long-description',
                content: el.querySelector('.c-long-service-description'),
                interactive: true,
                trigger: 'click',
                placement: 'bottom-start',
                appendTo: document.querySelector('.app__body .app__body__flex'),
                maxWidth: '400px',
                popperOptions: {
                    strategy: "fixed",
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: ['bottom', 'top', 'right'],
                                rootBoundary:  'viewport',
                            },
                        }, {
                            name: 'preventOverflow',
                            options: {
                                padding: {
                                    top: 20,
                                    bottom: 20,
                                    right: 130,
                                    left: 20
                                },
                                rootBoundary: 'viewport'
                            },
                        },]
                },
                plugins: [mainPlugin],
            })
        }
    };

    $scope.toggleInfo = function () {
        if ($scope.longDescriptionEnabled) {
        } else {
            $scope.infoShowed = !$scope.infoShowed;
        }
    };

    $scope.closePopper = function () {
        tippyInstance.hide();
        tippyInstance.unmount();
    }

    $scope.togglePreselected = function () {
        $scope.recall.selected = !$scope.recall.selected;
        $scope.onToggle && $scope.onToggle();
    };

    function formatRecallMessage() {
        var message = recallParserService.parse($scope.recall.comment);
        $scope.formatted = _.isPlainObject(message);
        if ($scope.formatted) {
            $scope.comment = message.comments;
            $scope.name = message.description || $scope.recall.name;
        } else {
            $scope.comment = message;
            $scope.name = $scope.recall.name;
        }
    }

    function init() {
        formatRecallMessage();
    }
}

const mainPlugin = {
    name: 'LongDescription',
    defaultValue: false,
    fn(instance) {

        let isInternalUpdate = false;
        let defaultAppendTo = instance.props.appendTo;
        const pluginsState = {
            size: null,
            strategy: instance.props.popperOptions?.strategy ?? 'absolute'
        };

        const positionModifier = {
            name: 'longDescriptionPosition',
            enabled: true,
            phase: 'main',
            requiresIfExists: ['offset'],
            fn: ({state}) => {

                let newTippyProps = {};
                let needChangeOffsets = false;
                let needChangeStrategy = false;
                let needUpdateTippyProps = false;
                let needRefresh = false;
                let needChangeAppendTo = false;

                let nextOffset;
                let nextStrategy;
                let nextAppendTo;

                const md = new MobileDetect(window.navigator.userAgent);
                const portraitMode = window.innerWidth > window.innerHeight;

                nextAppendTo = defaultAppendTo;

                if (md.phone()) {
                    nextOffset = {x: 0, y: 0};
                    if (portraitMode) nextStrategy = 'relative';
                    else {
                        nextStrategy = 'absolute';
                        nextAppendTo = document.querySelector('body');
                    }
                    newTippyProps.arrow = false;
                }
                    // else if (md.tablet()) {
                    //     if (!portraitMode && window.innerWidth < 1000 ||
                    //         portraitMode && window.innerHeight < 1000) {
                    //         nextOffset = {x: 0, y: 0};
                    //         if (portraitMode) nextStrategy = 'relative';
                    //         else nextStrategy = 'relative';
                    //         newTippyProps.arrow = false;
                    //     } else {
                    //         nextStrategy = 'fixed';
                    //         newTippyProps.arrow = true;
                    //     }
                // }
                else {
                    nextStrategy = 'fixed';
                    newTippyProps.arrow = true;
                }

                if (nextOffset) needChangeOffsets = true;
                if (nextStrategy && pluginsState.strategy !== nextStrategy) {
                    needChangeStrategy = true;
                    needUpdateTippyProps = true;
                }
                if (nextAppendTo && instance.props.appendTo !== nextAppendTo)
                    needChangeAppendTo = true;

                if (needChangeOffsets) {
                    if (state?.modifiersData?.popperOffsets) {
                        state.modifiersData.popperOffsets.x = nextOffset.x;
                        state.modifiersData.popperOffsets.y = nextOffset.y;
                    }
                }

                if (needChangeStrategy) {
                    pluginsState.strategy = nextStrategy;
                    newTippyProps.popperOptions ??= {};
                    newTippyProps.popperOptions.strategy = nextStrategy;
                }

                if (needChangeAppendTo) {
                    pluginsState.appendTo = nextAppendTo;
                    newTippyProps.appendTo = nextAppendTo;
                    needUpdateTippyProps = true;
                    needRefresh = true;
                }

                if (!_.eq(newTippyProps, {}) && !needUpdateTippyProps) {
                    if (newTippyProps?.arrow &&
                        newTippyProps.arrow !== instance.props.arrow)
                        needUpdateTippyProps = true;

                    if (newTippyProps?.popperOptions?.strategy &&
                        newTippyProps.popperOptions.strategy !== instance.props.popperOptions.strategy)
                        needUpdateTippyProps = true;
                }

                if (needUpdateTippyProps && !isInternalUpdate) {
                    const props = _.merge({
                        popperOptions: {
                            ...instance.props.popperOptions,
                        }
                    }, newTippyProps);
                    setInternalProps(props);
                }

                if (needRefresh) {
                    instance.hide();
                    instance.unmount();
                    instance.show();
                }
            },
        };

        const styleModifier = {
            name: 'longDescriptionStyle',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: ['offset'],
            fn: ({state}) => {

                const md = new MobileDetect(window.navigator.userAgent);
                const portraitMode = window.innerWidth > window.innerHeight;

                const attributes = {
                    'data-portrait-mode': (!!md.phone() || !!md.tablet()) && portraitMode,
                    'data-is-phone': !!md.phone(),
                    'data-is-table': !!md.tablet(),
                };

                const element = state.elements?.['popper']?.firstElementChild;
                if (!isHTMLElement(element) || !getNodeName(element)) {
                    return;
                }

                Object.keys(attributes).forEach(name => {
                    const value = attributes[name];
                    if (value === false) {
                        element.removeAttribute(name);
                    } else {
                        element.setAttribute(name, value === true ? '' : value);
                    }
                });
            }
        }

        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }

        function addModifiers() {
            if (!isInternalUpdate) {
                setInternalProps(getProps(instance.props, positionModifier));
                setInternalProps(getProps(instance.props, styleModifier));
            }
        }

        return {
            onMount: addModifiers,
            onAfterUpdate: addModifiers,
        };
    }
}

function getProps(props, modifier) {
    return {
        popperOptions: {
            ...props.popperOptions,
            modifiers: [
                ...(props.popperOptions?.modifiers || []).filter(
                    ({name}) => name !== modifier.name
                ),
                modifier,
            ],
        },
    };
}

export default ossRecallDirective;
